import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, spacing, border }) => ({
  container: {
    flexDirection: "row",
  },
  card: {
    borderRadius: border.radius.md,
    alignItems: "center",
    backgroundColor: colors.backgroundSurface,
    overflow: "hidden",
    aspectRatio: 16 / 9,
  },
  image: {
    ...StyleSheet.absoluteFill,
    width: "100%",
    height: "100%",
    _web: {
      transition: "transform 0.2s ease-in-out",
      _hover: {
        transform: "scale(1.02)",
      },
    },
  },
  meta: {
    flex: 1,
    justifyContent: "flex-start",
    gap: spacing(2),
    paddingVertical: spacing(1),
    paddingLeft: spacing(4),
    height: {
      xs: spacing(20),
      md: spacing(32),
    },
  },
  duration: {
    position: "absolute",
    bottom: spacing(2),
    right: spacing(2),
    backgroundColor: colors.backgroundScrim,
    paddingVertical: spacing(1),
    paddingHorizontal: spacing(2),
    borderTopLeftRadius: border.radius.xs,
  },
  progressBar: {
    position: "absolute",
    bottom: spacing(4),
    left: spacing(2),
    right: spacing(2),
    backgroundColor: colors.backgroundScrim,
    borderRadius: border.radius.xs,
    height: spacing(1),
  },
  progressAmount: {
    backgroundColor: colors.foregroundDefault,
    borderRadius: border.radius.xs,
    height: "100%",
  },
  description: {
    color: colors.foregroundDefaultMuted,
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  cover: [
    {
      width: initialTheme.spacing(42),
      height: initialTheme.spacing(42) * (9 / 16),
    }, // for 16:9
    {
      width: initialTheme.spacing(72),
      height: initialTheme.spacing(72) * (9 / 16),
    }, // for 16:9
    {
      width: initialTheme.spacing(96),
      height: initialTheme.spacing(96) * (9 / 16),
    }, // for 16:9
  ],
};

export default stylesheet;
